class FetchService {
  constructor($http, $rootScope) {
    if ($rootScope.globals)
      $http.defaults.headers.common["Authorization"] =
        "Bearer " + $rootScope.globals.currentUser.token;
    this.$http = $http;
  }

  getCareType() {
    return this.$http.get(
      "" + WEBSERVICEURL + "/dataagility/api/service.refcode/query?domain=CARE"
    );
  }
}

class UnitauditController {
  constructor(
    $http,
    $scope,
    DTOptionsBuilder,
    DTColumnBuilder,
    User,
    Constants,
    CONST,
    materialButtons,
    $rootScope,
    $location,
    FunctionService
  ) {
    $http.defaults.headers.common["Authorization"] =
      "Bearer " + $rootScope.globals.currentUser.token;
    this.datatableApi;
    this.user = User.getUser();
    this.name = "Unit Audit Summary";
    this.episodeValue = "";
    this.specialtyString = "";
    this.separationString = "";
    this.locale = "en-au";

    this.fytdOptions = [];
    this.fytd = {
      selectedFytd: undefined,
    };

    this.months = {
      selectedMonth: undefined,
    };
    this.monthOptions = {};

    // Search filters
    this.campus = {
      selectedCampus: null,
    };
    this.campusOptions = [];
    this.specialty = {
      selectedSpecialty: [],
    };
    this.specialtyOptions = {};
    this.caretypeOptions = [];
    this.caretype = {
      selectedCaretype: [],
    };
    this.allCareTypeOptions = [];
    this.patientclassOptions = [];
    this.patientclass = {
      selectedPatientclass: [],
    };

    Constants.getDivisionAndSpecialtyData().then(function (response) {
      $scope.vm.specialtyOptions = response.specialties;
      filterSpecialty(response.specialties);
      // Can load divisions if needed??
    });

    Constants.patientClassificationData().then(function successCallback(
      response
    ) {
      $scope.vm.patientclassOptions = response;
    });

    // callbacks for lx-selects and lx-date-picker
    this.specialtyCallback = specialtyCallback;
    this.campusCallback = campusCallback;
    this.monthCallback = monthCallback;
    this.yearCallback = yearCallback;
    this.caretypeCallback = caretypeCallback;
    this.patientclassCallback = patientclassCallback;
    this.filterPatientclass = filterPatientclass;
    this.filterCaretype = filterCaretype;

    this.currentYear = moment().format("YYYY");
    this.startMonthMoment = moment(
      "01/01/" + $scope.vm.currentYear,
      "DD/MMMM/YYYY"
    )
      .startOf("month")
      .format("L");
    this.endMonthMoment = moment(
      "31/01/" + $scope.vm.currentYear,
      "DD/MMMM/YYYY"
    )
      .endOf("month")
      .format("L");
    this.url =
      WEBSERVICEURL + "/dataagility/api/service.unitauditsummary/query?";
    this.initUrl = this.url;
    this.EOFY = moment("31/12/" + $scope.vm.currentYear, "DD/MM/YYYY");

    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(
      function (response) {
        $scope.vm.episodeValue =
          response.functionSettings.EpisodeValue.valueString;
        $scope.vm.episodeValueDecimalPlaces = $scope.vm.episodeValue === '$' ? 2 : 4;
        $scope.vm.functionSettings = response.functionSettings;

        Constants.campusData().then(function successCallback(response) {
          if (
            $scope.vm.user.role !== "Administrator" &&
            $scope.vm.functionSettings.LimitCampusDropDown &&
            $scope.vm.functionSettings.LimitCampusDropDown.isActive
          ) {
            let campusOptions = [];
            if (typeof $scope.vm.user.campus === "string") {
              campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
            } else {
              campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
            }
            $scope.vm.campusOptions = campusOptions;
            $scope.vm.campus.selectedCampus = campusOptions;
          } else {
            $scope.vm.campusOptions = response;
          }
        });

        $scope.vm.specialtyString =
          response.functionSettings.SpecialtyString.valueString;
        $scope.vm.separationString =
          response.functionSettings.SeparationString.valueString;
      }
    );

    materialButtons.render();

    materialButtons.processing();

    function initFYTD() {
      if (moment().month() < 6) {
        var year = moment().format("YYYY");
      } else {
        var year = moment().add(1, "year").format("YYYY");
      }

      for (var i = 0; i < 10; i++) {
        $scope.vm.fytdOptions.push(year - 1 + " - " + year);
        year--;
      }

      // Default to current financial year
      $scope.vm.fytd.selectedFytd = $scope.vm.fytdOptions[0];
    }

    $scope.initCallback = function (
      nRow,
      aData,
      iDisplayIndex,
      iDisplayIndexFull
    ) {
      // Datatables has finished init
      // Initialise searching
      if ($scope.vm.datatableApi) return;

      $scope.vm.datatableApi = this.api();

      // Update column headers even when no data returned
      setDtHeaders($scope.vm.datatableApi);

      // setup search filters
      search();

      // make sure DataTables doesn't sort month names alphabetically
      $.fn.dataTable.moment("MMMM");

      // set the table to a fixed height, so it never collapsed up and down
      $("#auditTable").closest(".dataTables_scrollBody").height(300);
    };

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption("ajax", {
        headers: {
          Authorization: "Bearer " + $rootScope.globals.currentUser.token,
        },
        url:
          $scope.vm.initUrl +
          "startDate=" +
          $scope.vm.startMonthMoment +
          "&endDate=" +
          $scope.vm.endMonthMoment +
          "&careType=" +
          checkParamCare($scope.vm.caretype.selectedCaretype) +
          "&patientClass=" +
          checkParam($scope.vm.patientclass.selectedPatientclass) +
          "",
        type: "GET",
        error: (xhr, error, thrown) => {
          if (thrown == "Unauthorized") {
            //window.location.replace(window.location.origin + '/login');
            console.log(
              "Unauthorized request with token: ",
              $rootScope.globals.currentUser.token
            );
          }
        },
      })
      .withDisplayLength(CONST.TABLEROWS)
      .withDataProp("data")
      .withOption("processing", true)
      // .withOption('serverSide', true)
      .withOption("sAjaxDataProp", "")
      .withOption("bLengthChange", false)
      .withPaginationType("simple_numbers")
      .withOption("rowCallback", function (row, data, index) {
        // Update column headers if data returned
        setDtHeaders($("#auditTable").DataTable());
      })
      .withOption("drawCallback", $scope.drawCallback)
      .withOption("initComplete", $scope.initCallback)
      .withOption("scrollY", "300px")
      .withOption("scrollX", "auto")
      .withOption("dom", '<"wrapper"rt<"table-footer"iBp>>')
      .withButtons([
        {
          extend: "print",
          text: "",
        },
        {
          extend: "csvHtml5",
          text: "",
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm"),
        },
        {
          extend: "excelHtml5",
          text: "",
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm"),
        },
        {
          text: "",
          action: function (e, dt, node, config) {
            dt.ajax.reload();
          },
        },
      ]);

    this.dtColumns = [
      DTColumnBuilder.newColumn("speciality")
        .withTitle("Loading...")
        .withOption("defaultContent", "")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("dischargeMonth")
        .withTitle("Loading...")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalEpisodes")
        .withTitle("Total Number<br>of Episodes")
        .withOption("defaultContent", "0")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalEpisodesRequireAudit")
        .withTitle("Total<br>Require Auditing")
        .withOption("width", "5%")
        .withOption("defaultContent", "0")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalEpisodesAudited")
        .withTitle("Total<br>Episodes Audited")
        .withOption("defaultContent", "0")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("percentageAudited")
        .withTitle("Total<br>Episodes Audited (%)")
        .withOption("defaultContent", "0")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric")
        .renderWith(function (data, type, full) {
          return parseFloat(data).toFixed(2);
        }),
      DTColumnBuilder.newColumn("episodesToBeAudited")
        .withTitle("Episodes<br>to be Audited")
        .withOption("defaultContent", "0")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("percentageToBeAudited")
        .withTitle("Episodes<br>to be Audited (%)")
        .withOption("defaultContent", "0")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric")
        .renderWith(function (data, type, full) {
          return parseFloat(data).toFixed(2);
        }),
      DTColumnBuilder.newColumn("totalCodingChange")
        .withTitle("Total<br>Coding Changes")
        .withOption("defaultContent", "0")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalDRGChange")
        .withTitle("Total<br>DRG Change")
        .withOption("defaultContent", "0")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalQueryGenerated")
        .withTitle("Total<br>Query Generated")
        .withOption("defaultContent", "0")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("sumTotalWIESChange")
        .withTitle("Loading...")
        .withOption("defaultContent", "0")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric")
        .renderWith(function (data, type, full) {
          return parseFloat(data).toFixed($scope.vm.episodeValueDecimalPlaces);
        }),
      DTColumnBuilder.newColumn("monthStatus")
        .withTitle("Status of<br>Audit Month")
        .withOption("defaultContent", "0")
        .withOption("width", "5%")
        .withClass("mdl-data-table__cell--non-numeric"),
    ];

    function setDtHeaders(table) {
      $(table.column(0).header()).html($scope.vm.specialtyString);
      $(table.column(1).header()).html(
        $scope.vm.separationString + "<br>Month"
      );
      $(table.column(11).header()).html(
        "Total<br>" + $scope.vm.episodeValue + " Change"
      );
    }

    function checkParam(param) {
      if (param.length !== 0) {
        return encodeURIComponent(param.join());
      } else {
        return "";
      }
    }

    function checkParamCare(param) {
      let codes = [];

      if (param.length !== 0) {
        angular.forEach(param, function (value, key) {
          codes.push(value.code);
        });

        return encodeURIComponent(codes.join());
      } else {
        return "";
      }
    }

    function selectFilter(column, filter) {
      if (typeof filter === "string") filter = ["" + filter + ""];

      if (column === 1 && typeof filter === "undefined") filter = [""];

      if (filter) {
        // convert array to datatables permissable regex string
        filter = filter.join("|");

        var auditTable = $scope.vm.datatableApi;

        auditTable.columns(column).search(filter, true, false).draw();
      }
    }

    $scope.reload = function () {
      if ($scope.vm.datatableApi) {
        var campus = "";
        if (
          $scope.vm.functionSettings.LimitCampusDropDown &&
          $scope.vm.functionSettings.LimitCampusDropDown.isActive
        ) {
          if (
            $scope.vm.user.role !== "Administrator" &&
            $scope.vm.campus.selectedCampus.length === 0
          ) {
            campus = $scope.vm.user.campus;
          } else {
            campus = $scope.vm.campus.selectedCampus;
          }
        } else {
          campus = $scope.vm.campus.selectedCampus;
        }
        let newUrl =
          $scope.vm.url +
          "startDate=" +
          $scope.vm.startMonthDisplay +
          "&endDate=" +
          $scope.vm.endMonthDisplay +
          "&careType=" +
          checkParamCare($scope.vm.caretype.selectedCaretype) +
          "&patientClass=" +
          checkParam($scope.vm.patientclass.selectedPatientclass) +
          "&campus=" +
          campus +
          "&specialty=" +
          checkParam($scope.vm.specialty.selectedSpecialty) +
          "";
        $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
      }
    };

    function campusCallback(_newValue, _oldValue) {
      $scope.reload();
    }

    function specialtyCallback(_newValue, _oldValue) {
      $scope.reload();
    }

    function yearCallback(_newValue, _oldValue) {
      var year = _newValue.substring(7, 11),
        year2 = _newValue.substring(0, 4),
        month = moment($scope.vm.startMonthMoment, "DD/MM/YYYY").format("MM"),
        startMonthMoment = moment("01/" + month + "/" + year, "DD/MM/YYYY"),
        startMonthDisplay,
        endMonthDisplay;

      // console.log(year2);

      $scope.vm.EOFY = moment("31/12/" + year2, "DD/MM/YYYY");

      // if month is after EOFY, we need to look at data from last year
      if (month > 6) {
        $scope.vm.startMonthDisplay = startMonthMoment
          .clone()
          .subtract(1, "y")
          .startOf("month")
          .format("L");
        $scope.vm.endMonthDisplay = startMonthMoment
          .clone()
          .subtract(1, "y")
          .endOf("month")
          .format("L");
      } else {
        $scope.vm.startMonthDisplay = startMonthMoment
          .clone()
          .startOf("month")
          .format("L");
        $scope.vm.endMonthDisplay = startMonthMoment
          .clone()
          .endOf("month")
          .format("L");
      }

      // All Months
      if ($scope.vm.months.selectedMonth === "All Months") {
        $scope.vm.startMonthDisplay = moment(
          "01/07/" + (year - 1),
          "DD/MM/YYYY"
        ).format("L");
        $scope.vm.endMonthDisplay = moment(
          "30/06/" + year,
          "DD/MM/YYYY"
        ).format("L");
      }

      $scope.reload();
    }

    function monthCallback(_newValue, _oldValue) {
      var year = $scope.vm.fytd.selectedFytd.substring(7, 11),
        month = moment("01/" + _newValue + "/" + year, "DD/MMMM/YYYY").format(
          "MM"
        ),
        startMonthMoment = moment(
          "01/" + month + "/" + year,
          "DD/MM/YYYY"
        ).startOf("month"),
        endMonthMoment = moment("01/" + month + "/" + year, "DD/MM/YYYY").endOf(
          "month"
        ),
        startMonthDisplay,
        endMonthDisplay;

      $scope.vm.startMonthMoment = startMonthMoment.clone();

      // if month is before EOFY, we need to look at data from last year
      if (month > 6) {
        $scope.vm.startMonthDisplay = startMonthMoment
          .subtract(1, "y")
          .format("L");
        $scope.vm.endMonthDisplay = endMonthMoment.subtract(1, "y").format("L");
      } else {
        $scope.vm.startMonthDisplay = startMonthMoment.format("L");
        $scope.vm.endMonthDisplay = endMonthMoment.format("L");
      }

      // All Months
      if (_newValue === "All Months") {
        $scope.vm.startMonthDisplay = moment(
          "01/07/" + (year - 1),
          "DD/MM/YYYY"
        ).format("L");
        $scope.vm.endMonthDisplay = moment(
          "30/06/" + year,
          "DD/MM/YYYY"
        ).format("L");
      }

      $scope.reload();
    }

    function filterSpecialty(swap) {
      $scope.vm.specialty.selectedSpecialty = [];
      if (swap === "add") {
        $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
      }
    }

    function filterMonth() {
      var months = moment.months(),
        thisMonth = moment().format("MM"),
        year;

      $scope.vm.monthOptions = months;
      $scope.vm.monthOptions.unshift("All Months");
      $scope.vm.months.selectedMonth = $scope.vm.monthOptions[thisMonth - 1];

      if (moment().startOf("month").isAfter($scope.vm.EOFY)) {
        year = moment().format("YYYY");
      } else {
        year = moment().add(1, "year").format("YYYY");
      }

      $scope.vm.startMonthMoment = moment(
        "01/" + thisMonth + "/" + year,
        "DD/MM/YYYY"
      ).startOf("month");
    }

    function search() {
      // delete any global searches previously applied
      if ($.fn.dataTable.ext.search.length === 1)
        $.fn.dataTable.ext.search.shift();

      var auditTable = $scope.vm.datatableApi;
      var clearAuditTable = auditTable.search("").draw();

      filterSpecialty("minus");

      filterMonth();
      initFYTD();

      // Trigger filtering
      $(".reports__filters").find("div").first().find("div:last-child").click();
    }

    $scope.getCareType = function () {
      new FetchService($http, $scope).getCareType().then(
        function successCallback(response) {
          angular.forEach(response.data, function (value, key) {
            $scope.vm.caretypeOptions.push(value);

            if (value.description === "Acute inc Qual Newborn")
              $scope.vm.caretype.selectedCaretype.push(
                $scope.vm.caretypeOptions[key]
              );
          });
        },
        function errorCallback(response) {
          // $scope.feedback = "Error loading data";
          if (response.status === 401) {
            window.location.replace(
              window.location.origin + "/login?logout=true"
            );
          }
        }
      );
    };

    $scope.getCareType();

    function caretypeCallback(_newValue, _oldValue) {
      $scope.reload();
    }

    function patientclassCallback(_newValue, _oldValue) {
      $scope.reload();
    }

    function filterCaretype(swap) {
      $scope.vm.caretype.selectedCaretype = [];

      if (swap !== "minus") {
        angular.forEach($scope.vm.caretypeOptions, function (value, key) {
          $scope.vm.caretype.selectedCaretype.push(value);
        });
      }
    }

    function filterPatientclass(swap) {
      $scope.vm.patientclass.selectedPatientclass = [];

      if (swap !== "minus") {
        $scope.vm.patientclass.selectedPatientclass =
          $scope.vm.patientclassOptions;
      }
    }

    // bind the datatable instance to an object to monitor loading
    this.dtInstanceCallback = dtInstanceCallback;

    function dtInstanceCallback(dtInstance) {
      $scope.dtInstance = dtInstance._renderer;
    }

    // bind filter swap
    this.filterSwap = filterSwap;

    function filterSwap(thisFilter, thisModifier) {
      switch (thisFilter) {
        case "specialty":
          if (thisModifier === "add") {
            filterSpecialty("add");
          } else {
            filterSpecialty("minus");
          }
          break;
        default:
          break;
      }
    }
  }
}

export default UnitauditController;



// WEBPACK FOOTER //
// ./client/app/common/reports/unitaudit/unitaudit.controller.js